export const InputWithSuggestionsTestID = {
    FIELD: 'input-field',
    CLEAR_BUTTON: 'input-clear-button',
    VALID_ICON: 'input-valid-icon',
    SUGGESTIONS: 'input-suggestions',
    SUGGESTION_ITEM: 'input-suggestion-item',
};
